<template>
  <div>
    <Ribbon
      v-if="location != undefined"
      :fixed="true"
      :size="120"
      :text="location"
      background-color="#bfdc7a"
      text-color="#6a6340"
      url="https://github.com/thegetty/research_collections_viewer"
    />
    <router-view />
  </div>
</template>

<script>
import "@thegetty-private/getty-ui/dist/getty-ui.css";
import { useLocalization, Ribbon } from "@thegetty-private/getty-ui";
import { settings } from "@thegetty-private/rad-app-utils";
import { useHead } from "@unhead/vue";

export default {
  name: "App",
  components: {
    Ribbon
  },
  provide() {
    return {
      /**
       * The Base Url for the IIIF image requests -- allows us to use a different one for staging and production
       */
      IIIF_IMAGE_BASEURL: this.iiifImageBaseUrl
    };
  },
  setup() {
    return {
      ...useLocalization({})
    };
  },
  computed: {
    /**
     * Gets the IIIF Base Url from the environment (vault)
     *
     * @returns {string}
     */
    iiifImageBaseUrl() {
      return settings.getIiifImageBaseUrl();
    },
    /**
     * The banner location to display
     * @returns {string}
     */
    location() {
      return settings.getLocationBanner();
    }
  },
  mounted() {
    useHead({
      // what goes in the <title> tag and shows up as the browser's tab name
      title: this.translatePart("homepage.title"),
      // all titles will be injected into this template
      titleTemplate: this.translatePart("homepage.title_template"),
      meta: [
        // these fields will render as <meta name="" content="">
        {
          name: "title",
          content: this.translatePart("homepage.metadata_title")
        },
        // default meta description - should be 158 or fewer characters, currently over
        {
          name: "description",
          content: this.translatePart("homepage.metadata_description")
        }
      ]
    });
  }
};
</script>
